import { BaseQueryFn, EndpointBuilder, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Division, ResponseList } from "types";
import apiRoutes from "../apiRoutes";

export const divisionApi = (builder: EndpointBuilder<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, string, "api">) => ({
    getDivision: builder.query<ResponseList<Division>, void>({
        query: () => apiRoutes.getDivision,
    }),
})